import { Agency } from '@app/models';
import { DictionaryEntity, PcsEntity } from '@app/pcs/models';
import { EntityType, PropertyNameMapper } from '@app/shared/forms/property-mapper';
import { gql } from 'apollo-angular';

export interface TrainId {
  companyCode: Agency;
  coreElement: string;
  ttpId?: number;
  objectType?: DictionaryEntity;
}


export const trainIdMapper = new PropertyNameMapper({
  companyCode: 'companyCode',
  coreElement: 'coreElement'
}, {entityName: PcsEntity.TrainId, entityType: EntityType.Object});


export const trainId = gql`
    fragment trainId on DossierTrainId {
        companyCode {
            id
            name
            uicId
        }
        coreElement
        ttpId
        objectType {
            id
        }
    }
`;
